import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

type Props = ComponentPropsWithoutRef<'th'> & {
  padding?: number | null | undefined
}

/**
 * 基本的なThコンポーネント
 */
export const BasicTh: FC<Props> = ({
  children,
  className,
  padding,
  ...props
}) => {
  return (
    <th
      {...props}
      className={clsx([
        'text-left font-bold text-secondary',
        padding === 0 || padding ? `p-${padding}` : 'p-4',
        className
      ])}
    >
      {children}
    </th>
  )
}
